var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8573_80232)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1094 114.844H237.891C241.127 114.844 243.75 117.467 243.75 120.703V144.141C243.75 147.377 241.127 150 237.891 150H230.743L208.416 239.309C208.1 240.577 207.369 241.703 206.339 242.508C205.309 243.312 204.04 243.75 202.733 243.75H97.264C95.957 243.75 94.6876 243.312 93.6578 242.508C92.6279 241.703 91.8967 240.577 91.5804 239.309L69.2533 150H62.1094C58.8733 150 56.25 147.377 56.25 144.141V120.703C56.25 117.467 58.8733 114.844 62.1094 114.844Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 220.312C148.446 220.312 146.956 219.695 145.857 218.596C144.758 217.497 144.141 216.007 144.141 214.453V179.297C144.141 177.743 144.758 176.253 145.857 175.154C146.956 174.055 148.446 173.438 150 173.438C151.554 173.438 153.044 174.055 154.143 175.154C155.242 176.253 155.859 177.743 155.859 179.297V214.453C155.859 216.007 155.242 217.497 154.143 218.596C153.044 219.695 151.554 220.312 150 220.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.703 220.312C119.149 220.312 117.659 219.695 116.56 218.596C115.461 217.497 114.844 216.007 114.844 214.453V179.297C114.844 177.743 115.461 176.253 116.56 175.154C117.659 174.055 119.149 173.438 120.703 173.438C122.257 173.438 123.747 174.055 124.846 175.154C125.945 176.253 126.562 177.743 126.562 179.297V214.453C126.562 216.007 125.945 217.497 124.846 218.596C123.747 219.695 122.257 220.312 120.703 220.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.297 220.312C177.743 220.312 176.253 219.695 175.154 218.596C174.055 217.497 173.438 216.007 173.438 214.453V179.297C173.438 177.743 174.055 176.253 175.154 175.154C176.253 174.055 177.743 173.438 179.297 173.438C180.851 173.438 182.341 174.055 183.44 175.154C184.539 176.253 185.156 177.743 185.156 179.297V214.453C185.156 216.007 184.539 217.497 183.44 218.596C182.341 219.695 180.851 220.312 179.297 220.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.5469 79.6875H120.703C122.257 79.6875 123.747 80.3048 124.846 81.4037C125.945 82.5025 126.562 83.9929 126.562 85.5469V114.844H79.6875V85.5469C79.6875 83.9929 80.3048 82.5025 81.4037 81.4037C82.5025 80.3048 83.9929 79.6875 85.5469 79.6875Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.422 56.25H167.578C169.132 56.25 170.622 56.8673 171.721 57.9662C172.82 59.065 173.438 60.5554 173.438 62.1094V114.844H126.562V62.1094C126.562 60.5554 127.18 59.065 128.279 57.9662C129.378 56.8673 130.868 56.25 132.422 56.25V56.25Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.297 67.9688H214.453C216.007 67.9688 217.497 68.5861 218.596 69.6849C219.695 70.7838 220.312 72.2741 220.312 73.8281V114.844H173.438V73.8281C173.438 72.2741 174.055 70.7838 175.154 69.6849C176.253 68.5861 177.743 67.9688 179.297 67.9688Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8573_80232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187.5,
    height: 187.5,
    fill: "white",
    transform: "translate(56.25 56.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/emptyCart.0450f8e7f6b50f112df6549e29f1cd9b.svg";
export { ForwardRef as ReactComponent };